import { render, staticRenderFns } from "./ModgroupModal.vue?vue&type=template&id=2119391f&scoped=true"
import script from "./ModgroupModal.vue?vue&type=script&lang=ts"
export * from "./ModgroupModal.vue?vue&type=script&lang=ts"
import style0 from "./ModgroupModal.vue?vue&type=style&index=0&id=2119391f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119391f",
  null
  
)

export default component.exports